import { Box, Stack, Tabs, Typography } from "@mui/material";
import {
  MaterialInventoriesPermission,
  MaterialPermission,
} from "commons/enum/permission";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { XTab } from "share-components/mui-wrap/tab/x-tab";
import { PageContainer } from "share-components/templates/page/page-container";
import { MaterialGoodsIssueList } from "./material-goods-issue-list/material-goods-issue-list";
import { MaterialGoodsReceiptList } from "./material-goods-receipt-list/material-goods-reciept-list";
import { MaterialInventoryList } from "./material-inventory-list/material-inventory-list";
import { MaterialList } from "./material-list/material-list";

export const MaterialInventory = observer(() => {
  return (
    <PageContainer>
      <Outlet></Outlet>
    </PageContainer>
  );
});
export enum MaterialInventoryTab {
  Material = "Material",
  MaterialInventory = "MaterialInventory",
  MaterialGoodsReceipt = "MaterialGoodsReceipt",
  MaterialGoodsIssue = "MaterialGoodsIssue",
}
export const MaterialInventoryHome = observer(() => {
  const {
    materialInventoryManagement: { tabSelected, setProp },
  } = useStores();
  const { accessKey, allowAccess } = useCheckPermission([
    MaterialInventoriesPermission.Default,
    MaterialPermission.Default,
    MaterialInventoriesPermission.Receipt,
    MaterialInventoriesPermission.Issue,
  ]);

  useEffect(() => {
    if (allowAccess && accessKey) {
      const getTabSelected = (accessKey: string) => {
        switch (accessKey) {
          case MaterialInventoriesPermission.Default:
            return MaterialInventoryTab.MaterialInventory;
          case MaterialPermission.Default:
            return MaterialInventoryTab.Material;
          case MaterialInventoriesPermission.Receipt:
            return MaterialInventoryTab.MaterialGoodsReceipt;
          case MaterialInventoriesPermission.Issue:
            return MaterialInventoryTab.MaterialGoodsIssue;
          default:
            return null;
        }
      };
      setProp("tabSelected", getTabSelected(accessKey));
    }
  }, [accessKey, allowAccess, setProp]);
  return (
    <Stack
      flex={1}
      direction={"column"}
      gap={2}
      sx={{ overflow: "hidden" }}
    >
      <Stack direction={"row"}>
        <Typography variant="subtitle2">Quản lý tồn kho</Typography>
      </Stack>
      <Box>
        <Tabs
          value={tabSelected}
          onChange={(_, value) => {
            setProp("tabSelected", value);
          }}
        >
          <XTab
            accessPermission={[MaterialPermission.Default]}
            label="Quản lý vật tư "
            value={MaterialInventoryTab.Material}
          />
          <XTab
            accessPermission={[MaterialInventoriesPermission.Default]}
            label="Tồn kho vật tư "
            value={MaterialInventoryTab.MaterialInventory}
          />
          <XTab
            accessPermission={[MaterialInventoriesPermission.Receipt]}
            label="Nhập kho"
            value={MaterialInventoryTab.MaterialGoodsReceipt}
          />
          <XTab
            accessPermission={[MaterialInventoriesPermission.Issue]}
            label="Xuất kho"
            value={MaterialInventoryTab.MaterialGoodsIssue}
          />
        </Tabs>
      </Box>
      <Stack flex={1} sx={{ overflow: "hidden", paddingBlockStart: 1 }}>
        {tabSelected === MaterialInventoryTab.Material && <MaterialList />}
        {tabSelected === MaterialInventoryTab.MaterialInventory && (
          <MaterialInventoryList />
        )}

        {tabSelected === MaterialInventoryTab.MaterialGoodsReceipt && (
          <MaterialGoodsReceiptList></MaterialGoodsReceiptList>
        )}

        {tabSelected === MaterialInventoryTab.MaterialGoodsIssue && (
          <MaterialGoodsIssueList></MaterialGoodsIssueList>
        )}
      </Stack>
    </Stack>
  );
});
